import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { sstyled as _sstyled } from 'intergalactic/utils/lib/core/index';
import { assignProps as _assignProps } from 'intergalactic/core';
import React from 'react';
import createComponent, { sstyled, Root } from 'intergalactic/core';
/*__reshadow-styles__:"./invalidStateBox.shadow.css"*/
var style = ( /*__reshadow_css_start__*/_sstyled.insert( /*__inner_css_start__*/".___SPattern_1j03v_gg_{width:6px;height:100%;position:absolute;background-image:var(--intergalactic-border-critical-pattern, repeating-linear-gradient(315deg, rgba(209, 0, 47, 1) 0, rgba(209, 0, 47, 1) 2px, transparent 0, transparent 50%));background-size:6px 6px;background-color:var(--intergalactic-bg-primary-neutral, #ffffff);border-bottom-left-radius:var(--intergalactic-control-rounded, 6px);border-top-left-radius:var(--intergalactic-control-rounded, 6px)}" /*__inner_css_end__*/, "1j03v_gg_") /*__reshadow_css_end__*/, {
  "__SPattern": "___SPattern_1j03v_gg_"
});
import Box from '../Box';
var InvalidStatePatternComponent = function InvalidStatePatternComponent() {
  var _ref = arguments[0],
    _ref2;
  var SPattern = Box;
  return _ref2 = sstyled(style), /*#__PURE__*/React.createElement(SPattern, _ref2.cn("SPattern", _objectSpread({}, _assignProps({}, _ref))));
};
export var InvalidStateBox = createComponent(InvalidStatePatternComponent);
export default InvalidStateBox;
//# sourceMappingURL=InvalidStateBox.js.map